module.exports = __webpack_public_path__ + "static/media/temp_2.e05fc08c.jpg";